import createSelector from 'web-app/util/custom-create-selector';
export const isLoggingIn = (state) => state.login.isLoggingIn;
export const accessToken = (state) => state.login.accessToken;
export const isPinApp = (state) => state.login.pinSigninAvailable;
export const isQrSignin = (state) => state.login.qrSigninAvailable;
export const getSiteId = (state) => state.login.siteId;
export const isLoggedIn = createSelector(accessToken, token => Boolean(token));
